import { useEffect, useState } from 'react';
import { useAppContext } from '../../Context';
import { useAppDispatch } from '../../hooks';
import { setLoading, setPopAlert } from '../../slices/miscSlice';
import { Button } from '../../components/shared/FormElements';
import { SiigoIntegrationType } from '../../types';
import { usePermissions } from '../../services';

type ViewSiigoIntegrationProps = {
  onConfiguredChange?: (configured: boolean) => void;
};

const ViewSiigoIntegration: React.FC<ViewSiigoIntegrationProps> = ({ onConfiguredChange }) => {
  const { apiCall } = useAppContext();
  const dispatch = useAppDispatch();
  const { canAdd_customer } = usePermissions(['add_customer']);
  const [form, setForm] = useState({
    access_user: '',
    access_key: '',
    partner_id: '',
  });

  useEffect(() => {
    const fetchIntegration = async () => {
      dispatch(setLoading(true));
      const response = (await apiCall('GET', 'siigo-integration/', null, '', 'Error al cargar Siigo')) as
        | SiigoIntegrationType
        | undefined;
      dispatch(setLoading(false));
      if (response?.configured) {
        setForm({
          access_user: response.access_user,
          access_key: response.access_key,
          partner_id: response.partner_id,
        });
        if (onConfiguredChange) onConfiguredChange(true);
      } else if (onConfiguredChange) {
        onConfiguredChange(false);
      }
    };

    fetchIntegration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (field: string, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    dispatch(setLoading(true));
    const response = await apiCall('POST', 'siigo-integration/', form, '', 'Error al guardar Siigo');
    dispatch(setLoading(false));
    if (response) {
      dispatch(
        setPopAlert({
          alertType: 'success',
          message: 'Integración Siigo guardada correctamente',
          show: true,
        }),
      );
      if (onConfiguredChange) onConfiguredChange(true);
    } else {
      dispatch(
        setPopAlert({
          alertType: 'error',
          message: 'No se pudo guardar la integración Siigo',
          show: true,
        }),
      );
    }
  };

  return (
    <div className='form-container'>
      <div className='form-group'>
        <label>Access User</label>
        <input
          className='settings-input form-control'
          type='email'
          value={form.access_user}
          onChange={(e) => handleChange('access_user', e.target.value)}
          disabled={!canAdd_customer}
        />
      </div>
      <div className='form-group'>
        <label>Access Key</label>
        <input
          className='settings-input form-control'
          type='text'
          value={form.access_key}
          onChange={(e) => handleChange('access_key', e.target.value)}
          disabled={!canAdd_customer}
        />
      </div>
      <div className='form-group'>
        <label>Partner ID</label>
        <input
          className='settings-input form-control'
          type='text'
          value={form.partner_id}
          onChange={(e) => handleChange('partner_id', e.target.value)}
          disabled={!canAdd_customer}
        />
      </div>
      {canAdd_customer && (
        <Button className='btn btn-primary' onClick={handleSave}>
          Guardar integración Siigo
        </Button>
      )}
    </div>
  );
};

export default ViewSiigoIntegration;
